import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m17.382 5.408-.286-1.828c-.073-.282-.396-.462-.804-.44-2.127.143-8.183.6-9.07 2.268-1.107 2.308 4.67 2.646 1.66-2.119l-.33-.702c-.083-.343-.68-.397-.99-.118L1.866 8.222c-.204.2-.166.445.09.573l7.082 3.694c.383.192.958-.086.903-.434l-.258-1.47c-.032-.204.172-.403.46-.448l1.152-.16"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m6.455 18.608.41 1.804c.092.277.426.434.832.385 2.112-.288 8.123-1.156 8.894-2.881.947-2.379-4.84-2.322-1.512 2.227l.377.678c.107.336.706.35.996.05l5.29-6.127c.19-.213.136-.456-.128-.566l-7.317-3.203c-.396-.165-.95.151-.872.495l.358 1.448c.046.202-.144.415-.428.479l-1.14.237"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ChangingIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
